import { endsWith } from 'ramda';
import { IAppState } from '../../redux';

export function selectAutoProlongHint(state: IAppState): string {
  const {
    checkoutInfo: {
      autoProlongInfo: { hintText, tooltipText },
    },
  } = state;

  if (hintText && tooltipText) {
    const hasDot = endsWith('.', hintText);
    const separator = hasDot ? ' ' : '. ';

    return`${hintText}${separator}${tooltipText}`;
  }

  if (hintText) {
    return hintText;
  }

  return tooltipText;
}
